/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/
import mutations from "./mutations.js"
import actions from "./actions.js"
import getters from "./getters.js"

export default {
  state() {
    const saved = localStorage.getItem('cognitoUser')
    return {
      cognitoUser: saved ? JSON.parse(saved) : {}
    };
  },
  mutations,
  actions,
  getters,
};
